import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateWords } from '../state_words';

interface Payload {
  language: string;
  words: string[];
}

export const local_words_translating_in_progress_add = (payload: Payload): PayloadAction<Payload> => ({
  type: ENUM__redux_action.WORDS_TRANSLATING_IN_PROGRESS_ADD,
  payload,
});

export const init_local_words_translating_in_progress_add = (state: StateWords, action: PayloadAction<Payload>) => {
  let { language, words } = action.payload;

  let wordsInLanguage = state.words_translating_in_progress.get(language) || new Set<string>();

  for (let word of words) {
    wordsInLanguage.add(word);
  }

  state.words_translating_in_progress.set(language, wordsInLanguage);

  //need to update map to trigger re-render
  state.words_translating_in_progress = new Map(state.words_translating_in_progress);
};
